const calculateNextWalletCosts = (walletCosts, targetWalletId, newAmount) => {
  if (!walletCosts) {
    return {};
  }
  const targetWalletGroup = walletCosts.find((walletProviderGroups) => walletProviderGroups[0].walletId === targetWalletId);
  const otherWalletGroups = walletCosts.filter((walletProviderGroups) => walletProviderGroups[0].walletId !== targetWalletId);

  const updatedTargetWalletGroup = targetWalletGroup.map((walletProviderCost) => {
    return { ...walletProviderCost, purchaseAmount: newAmount };
  });

  return [...otherWalletGroups, updatedTargetWalletGroup];
};

const calculateNextProviderOrInsuranceCosts = (costs, targetWalletId, newAmount) => {
  if (!costs) {
    return {};
  }
  const targetCost = costs.find((costInfo) => `${costInfo?.walletId}` === `${targetWalletId}`);
  if (!targetCost) {
    return costs;
  }
  const otherCosts = costs.filter((costInfo) => `${costInfo?.walletId}` !== `${targetWalletId}`);

  const updatedTargetCost = { ...targetCost, purchaseAmount: newAmount };

  return [...otherCosts, updatedTargetCost];
};

export const calculateNextCostReviewState = (costReviewData, targetWalletId, newAmount) => {
  return {
    ...costReviewData,
    walletCosts: calculateNextWalletCosts(costReviewData?.walletCosts, targetWalletId, newAmount),
    providerCosts: calculateNextProviderOrInsuranceCosts(costReviewData?.providerCosts, targetWalletId, newAmount),
    insuranceCosts: calculateNextProviderOrInsuranceCosts(costReviewData?.insuranceCosts, targetWalletId, newAmount),
  };
};
